import { Component, Input, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '@env/environment';
import { CopyTextDialogComponent } from '../copy-text-dialog/copy-text-dialog.component';

@Component({
  selector: 'app-share-requirements-button',
  standalone: true,
  imports: [MatButtonModule],
  templateUrl: './share-requirements-button.component.html',
  styleUrl: './share-requirements-button.component.scss',
})
export class ShareRequirementsButtonComponent implements OnInit {
  @Input() publicId!: string | null;

  requirementsUrl!: string;

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {
    this.requirementsUrl = environment.SHARE_URL + '/enquiry/' + this.publicId;
  }

  shareRequirements(): void {
    const dialogRef = this.dialog.open(CopyTextDialogComponent, {
      data: { text: this.requirementsUrl },

      position: { top: '10%' },
      panelClass: 'custom-dialog-container',
    });
  }
}
